/* External */
import { useMemo, memo } from 'react';
import PropTypes from 'prop-types';

function VirtualizedItem({
  index, position, renderer: Renderer, firstVisibleElementIndex,
}) {
  const style = useMemo(() => ({
    position: 'absolute',
    width: '100%',
    top: `${position}px`,
    willChange: 'transform',
  }), [position]);

  return (
    <div style={style}>
      <Renderer index={index} firstVisibleElementIndex={firstVisibleElementIndex} />
    </div>
  );
}

VirtualizedItem.propTypes = {
  index: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
  renderer: PropTypes.elementType.isRequired,
  firstVisibleElementIndex: PropTypes.number.isRequired,
};

export default memo(VirtualizedItem);
